export default __webpack_public_path__ + "07d632b93d53181ba72b24064ae4cfae.png";